import { StationUnit } from "@/models/stationUnit.js"


// Breaker unit
export class Breaker extends StationUnit {
	// Passport key names
	static get passportKeys() {
		return Object.freeze({
			self: 'breaker',
			unitVersion: 'unit_version',
			unitPort: 'unit_port',
			unitModbusAddr: 'unit_modbus_addr',

			powerUnitAddr: 'power_unit_addr',
			serviceUnitAddr: 'service_unit_addr',
			breakerAddr: 'breaker_addr',
			currentOnDuration: 'current_on_duration',
			currentOffDuration: 'current_off_duration',
			breakerMode: 'breaker_mode',
			noGpsPowerUnitMode: 'no_gps_power_unit_mode',
			akkEmptyVoltage: 'akk_empty_voltage',
			akkFullVoltage: 'akk_full_voltage',
			rs485MasterSpeed: 'rs485_master_speed',
			rs485SlaveSpeed: 'rs485_slave_speed',
			rs485MasterStopBits: 'rs485_master_stop_bits',
			rs485SlaveStopBits: 'rs485_slave_stop_bits',

			relatedRpc: 'related_rpc'
		})
	}

	static get metricKeys() {
		return Object.freeze({
			isConnect: 'is_connection',
			// Pure metrics
			unitName: 'unit_name',
			assemblydate: 'assembly_date',
			fBreakerActive: 'f_breaker_active',
			fEepromError: 'f_eeprom_error',
			fServiceUnitConnectionError: 'f_service_unit_connection_error',
			fPowerUnitConnectionError: 'f_power_unit_connection_error',
			fGpsDataOk: 'f_gps_data_ok',
			currentOnDurationFact: 'current_on_duration_fact',
			currentOffDurationFact: 'current_off_duration_fact',
			// Settings
			powerUnitAddr: Breaker.passportKeys.powerUnitAddr,
			serviceUnitAddr: Breaker.passportKeys.serviceUnitAddr,
			breakerAddr: Breaker.passportKeys.breakerAddr,
			currentOnDuration: Breaker.passportKeys.currentOnDuration,
			currentOffDuration: Breaker.passportKeys.currentOffDuration,
			breakerMode: Breaker.passportKeys.breakerMode,
			noGpsPowerUnitMode: Breaker.passportKeys.noGpsPowerUnitMode,
			akkEmptyVoltage: Breaker.passportKeys.akkEmptyVoltage,
			akkFullVoltage: Breaker.passportKeys.akkFullVoltage,
			rs485MasterSpeed: Breaker.passportKeys.rs485MasterSpeed,
			rs485SlaveSpeed: Breaker.passportKeys.rs485SlaveSpeed,
			rs485MasterStopBits: Breaker.passportKeys.rs485MasterStopBits,
			rs485SlaveStopBits: Breaker.passportKeys.rs485SlaveStopBits,
		})
	}

	get metricKeys() {
		return Breaker.metricKeys
	}

	// Breaker unit versions
	static get versions() {
		return Object.freeze({
			v2025: '2025',
			unknown: 'unknown',
		})
	}

	// Unit version names
	static get versionNames() {
		return Object.freeze({
			[Breaker.versions.unknown]: 'невідома',
			[Breaker.versions.v2025]: '2025УН',
		})
	}

	static get settingNames() {
		return Object.freeze({
			[Breaker.passportKeys.unitVersion]: 'Версія переривача',
			[Breaker.passportKeys.unitPort]: 'Порт переривача',
			[Breaker.passportKeys.unitModbusAddr]: 'ModBus адреса переривача',

			[Breaker.passportKeys.powerUnitAddr]: 'ModBus адреса силового модуля',
			[Breaker.passportKeys.serviceUnitAddr]: 'ModBus адреса сервісного модуля',
			[Breaker.passportKeys.breakerAddr]: 'Власна ModBus адреса переривача',
			[Breaker.passportKeys.currentOnDuration]: 'Тривалість подачі струму катодного захисту',
			[Breaker.passportKeys.currentOffDuration]: 'Тривалість переривання струму катодного захисту',
			[Breaker.passportKeys.breakerMode]: 'Режим переривання',
			[Breaker.passportKeys.noGpsPowerUnitMode]: 'Режим роботи станції при відсутності даних з супутників',
			[Breaker.passportKeys.akkEmptyVoltage]: 'Напруга на акумуляторі що відповідає 0%',
			[Breaker.passportKeys.akkFullVoltage]: 'Напруга на акумуляторі що відповідає 100%',
			[Breaker.passportKeys.rs485MasterSpeed]: 'Швидкість інтерфейсу RS485 Master',
			[Breaker.passportKeys.rs485SlaveSpeed]: 'Швидкість інтерфейсу RS485 Slave',
			[Breaker.passportKeys.rs485MasterStopBits]: 'Кількість стоп біт інтерфейсу RS485 Master',
			[Breaker.passportKeys.rs485SlaveStopBits]: 'Кількість стоп біт інтерфейсу RS485 Slave',
		})
	}

	static get rs485SpeedList() {
		return Object.freeze([4800, 9600, 14400, 19200, 38400, 57600])
	}

	static get alertPromts() {
		return Object.freeze({
			[Breaker.metricKeys.fEepromError]: 'помилка мікросхеми EEPROM пам\'яті',
			[Breaker.metricKeys.fServiceUnitConnectionError]: 'немає зв\'язку з сервісним модулем',
			[Breaker.metricKeys.fPowerUnitConnectionError]: 'немає зв\'язку з силовим модулем',
			[Breaker.metricKeys.fGpsDataOk]: 'невірні дані з GPS супутників',
		})
	}
	get alertPromts() { return Breaker.alertPromts }

	static get breakerModes() {
		return Object.freeze([
			{
				value: 0,
				text: 'Переривання заборонені',
			},
			{
				value: 1,
				text: 'Переривання дозволені',
			},
		])
	}

	get passport() {
		return this._passport.get(Breaker.passportKeys.self)
	}

	get isPresent() {
		if (!this.passport 
			|| !this.passport[Breaker.passportKeys.unitVersion]
			|| this.passport[Breaker.passportKeys.unitVersion] == Breaker.versions.unknown
		) {
			return false
		} else {
			return true
		}
	}

	// Paste in unit realization
	// Return unit connection metric
	get isConnect() {
		// If not present
		if (!this.isPresent) {
			return false
		}

		if (this.metrics.has(Breaker.metricKeys.isConnect)) {
			return this.metrics.get(Breaker.metricKeys.isConnect).value
		} else {
			return false
		}
	}
}